// @ts-ignore
/* eslint-disable */
import { ENDPOINTS } from '@/config/api';
import api from '@/utils/api';
import { request } from '@umijs/max';
import type { UserPermissionsResponse } from '@/services/permission/api';

/** Get user list GET /user */
export async function getUsers(params?: {
  /** Current page number */
  current?: number;
  /** Page size */
  pageSize?: number;
  /** Keyword search */
  keyword?: string;
  /** Status filter */
  status?: string;
  /** Username filter */
  username?: string;
  /** Full Name (EN) filter */
  full_name_en?: string;
  /** Full Name (ZH) filter */
  full_name_zh?: string;
  /** Nickname filter */
  nickname?: string;
  /** Hong Kong phone filter */
  phone?: string;
  /** Staff ID filter */
  staff_id?: string;
  /** Role ID filter */
  role_id?: string | string[];
  /** Department ID filter */
  department_id?: string;
  /** Region ID filter */
  region_id?: string;
  /** Include deleted users in the response */
  includeDeleted?: boolean;
}) {
  return api.get<API.UserListItem[]>(ENDPOINTS.USER.LIST, params);
}

/** Add user POST /user */
export async function addUser(data: API.UserListItem) {
  return api.post<API.UserListItem>(ENDPOINTS.USER.CREATE, data, { skipErrorHandler: true });
}

/** Get user details GET /user/${id} */
export async function getUser(id: string) {
  const response = await api.get<API.UserListItem>(ENDPOINTS.USER.UPDATE(id));
  return (response as any)?.data ?? response;
}

/** Update user PATCH /user/${id} */
export async function updateUser(id: string, data: API.UserListItem) {
  return api.patch<API.UserListItem>(ENDPOINTS.USER.UPDATE(id), data, {
    skipErrorHandler: true,
  });
}

/** Delete user DELETE /user/${id} */
export async function deleteUser(id: string) {
  return updateUser(id, { status: 'deleted' } as API.UserListItem);
}

export type UserRolePreview = Pick<
  UserPermissionsResponse,
  'permissions' | 'roleAssignments' | 'roles_version'
>;

/** Preview effective permissions for an unsaved internal-account role selection. */
export async function previewUserRoles(data: { role_ids: string[]; user_id?: string }) {
  return request<UserRolePreview>('/api/user/role-preview', { method: 'POST', data });
}
